import { Component, OnInit, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Events } from "../../helpers/events";

@Component({
    selector: 'app-county-filter',
    templateUrl: './county-filter.component.html',
    styleUrls: ['./county-filter.component.scss'],
})
export class CountyFilterComponent implements OnInit {

    @Input() counties: string[] = [];
    @Input() selected: string[] = [];

    constructor(
        public appEvents: Events,
        private popoverController: PopoverController
    ) { }

    ngOnInit() { }

    filterChanged(event) {
        if (!event.detail.checked) {
            let index = this.selected.indexOf(event.detail.value);
            if (index !== -1) {
                this.selected.splice(index, 1);
            }
        } else if (event.detail.checked && !this.selected.filter((item) => { return item == event.detail.value }).length) {
            this.selected.push(event.detail.value);
        }

        return false;
    }

    /* Check, if the county is selected
     *
     * @param county
     * @returns {boolean}
     */
    public isChecked(county: string) {
        // console.log('isChecked', county);
        if (this.selected.filter((item) => { return item == county }).length) {
            return true;
        }

        return false;
    }

    async DismissClick() {
        await this.popoverController.dismiss({
            // selected: this.selected
        });
    }

}
